function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

// TODO This is bad. Should not inject context into service class like this.
function getLang() {
    if (window.tkcWidgetContext && window.tkcWidgetContext.language) { 
        return window.tkcWidgetContext.language;
    }
    return 'en';
}

export default class TkcWebSameOriginService {
    static MEMBERSHIPS_BASE_URL = `/${getLang()}/memberships/api/`
    static CORE_BASE_URL = `/${getLang()}/api/`

    static fetchUserSubscriptions() {        
        return fetch(this.MEMBERSHIPS_BASE_URL + 'my-user-subscriptions/')
        .then((response) => {            
            return response.json();
        })
        .then((json) => {
            //console.log('XXXX', json);
            return json;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
    }    

    static fetchMemberships() {
        //console.log('ZZZZ', this.MEMBERSHIPS_BASE_URL + 'my-user-subscriptions/')
        return fetch(this.MEMBERSHIPS_BASE_URL + 'my-memberships/')
        .then((response) => {
            //console.log('YYY', response);
            return response.json();
        })
        .then((json) => {
            //console.log('XXX', json);
            return json;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
    }   

    static syncUserSubscriptionsWithNetsuite() {  
        const csrfToken = getCookie('csrftoken');        
        return fetch(this.MEMBERSHIPS_BASE_URL + 'my-user-subscriptions/sync/', {
            headers: {
                'X-CSRFToken': csrfToken,
            },
            method: 'post',            
        })
        .then((response) => {
            //console.log('YYY', response);
            return response.json();
        })
        .then((json) => {
            //console.log('XXX', json);
            return json;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
    }     

    static cancelUserSubscription(id) {     
        const csrfToken = getCookie('csrftoken');        
        return fetch(this.MEMBERSHIPS_BASE_URL + `my-user-subscriptions/${id}/cancel/`, {
            headers: {
                'X-CSRFToken': csrfToken,
            },
            method: 'post',            
        })
        .then((response) => {
            //console.log('YYY', response);
            return response.json();
        })
        .then((json) => {
            //console.log('XXX', json);
            return json;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
    }     
    
    static changeUserSubscriptions(payload) {     
        const csrfToken = getCookie('csrftoken');        
        return fetch(this.MEMBERSHIPS_BASE_URL + `my-user-subscriptions/change/`, {
            headers: {
                'X-CSRFToken': csrfToken,
                'Content-Type': 'application/json',
            },
            method: 'post',
            body: JSON.stringify(payload),
        })
        .then((response) => {
            //console.log('YYY', response);
            return response.json();
        })
        .then((json) => {
            //console.log('XXX', json);
            return json;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
    }    
    
    static changeCreditCard(payload) {     
        const csrfToken = getCookie('csrftoken');        
        return fetch(this.MEMBERSHIPS_BASE_URL + `my-user-subscriptions/change-cc/`, {
            headers: {
                'X-CSRFToken': csrfToken,
                'Content-Type': 'application/json',
            },
            method: 'post',
            body: JSON.stringify(payload),
        })
        .then((response) => {
            //console.log('YYY1', response);
            return response.json();
        })
        .then((json) => {
            //console.log('XXX1', json);
            return json;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
    }        

    static fetchPromotions(promoCode, membershipSlug, paymentFrequency, netsuiteCurrencyId) {   
        const url = `${this.MEMBERSHIPS_BASE_URL}my-promotions/?code=${promoCode}&membership=${membershipSlug}&payment_frequency=${paymentFrequency}&currency=${netsuiteCurrencyId}`            
        return fetch(url)
        .then((response) => {
            ////console.log('YYY', response);
            return response.json();
        }).then((json) => {
            //console.log('XXX', json);
            return json;
        }).catch((error) => {
            console.error(error);
            return null;
        })
    }       
    
    static subscribeToEmailList(email, name, listId) {     
        const csrfToken = getCookie('csrftoken');        
        return fetch(this.CORE_BASE_URL + 'subscribe/', {
            headers: {
                'X-CSRFToken': csrfToken,
                'Content-Type': 'application/json',
            },
            method: 'post',
            body: JSON.stringify({
                email: email,
                name: name,
                list_id: listId,
            }),
        })
        .then((response) => {
            //console.log('YYY1', response);
            return response.json();
        })
        .then((json) => {
            //console.log('XXX1', json);
            return json;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/TkcWebSameOriginService.js